import { useIsMobile } from '@/hooks/use-media-query';
import FeedPageDesktop from './FeedPageDesktop';
import MobileFeed from '@/pages/mobile/MobileFeed';

// Task #1720 — Dispatcher Feed: viewport-aware. La versione desktop completa
// (sidebar topic + composer ricco + filter tabs) vive in `FeedPageDesktop`,
// quella mobile (composer in bottom sheet, filtri in sheet, post card a tutta
// larghezza) in `pages/mobile/MobileFeed`. Tutta la logica feed (REST, socket,
// reactions, bookmark, boost, RSVP) è replicata nelle due implementazioni:
// nessun branch dead-code/duplicato in questo file.
export default function FeedPage() {
  const isMobile = useIsMobile();
  return isMobile ? <MobileFeed /> : <FeedPageDesktop />;
}
